export const languages = {
    ru: 'Русский',
    en: 'English',
};

export const FREE_COURSE_LANGUAGES = ['it', 'fr'];
